<template>
    <v-layout row wrap>
        <v-flex xs12>
            <h2>{{ metadata.mainText }}</h2>
            <v-card v-if="hasCrossWalk()" :elevation="1" class="crosswalk">
                <ul class="crosswalklist">
                    <li v-for="crossWalkItem in getCrossWalk()" :key="crossWalkItem">
                        {{ crossWalkItem }}
                    </li>
                </ul>
            </v-card>
            <p class="margined" v-if="metadata.htmlSubText" v-html="metadata.htmlSubText"></p>
        </v-flex>
    </v-layout>
</template>

<script>

export default {
	name: 'QuestionText',
	props: {
        metadata: Object
    },
    methods: {
        /**
         * Parses the metadata.crossWalk from a string in to an array.
         * If the json string field cannot resolve to an array or string return null.
         */
        getCrossWalk: function () {
            let crossWalkData = null;
            if (this.metadata.crossWalk) {
                let crossWalkObj = JSON.parse(this.metadata.crossWalk);
                if (Array.isArray(crossWalkObj)) {
                    crossWalkData = crossWalkObj;
                } else if (crossWalkObj instanceof String) {
                    crossWalkData = [ crossWalkData ];
                }
            }
            return crossWalkData;
        },
        /**
         * Returns true if the metadata.crossWalk field can be parsed to an array and
         * there is at least 1 item in the array.
         */
        hasCrossWalk: function () {
            let crossWalk = this.getCrossWalk();
            return crossWalk != null && crossWalk.length > 0;
        }
    }
};

</script>

<style scoped>

h1 {
    font-size: 19pt;
}

h2 {
  font-size: 17pt;
  margin-top: 5px;
  font-weight: bold;
  max-width: 1000px;
}

.margined {
    margin: 16px;
    max-width: 1000px;
}
ul.margined {
    margin: 15px 35px;
}
ul.margined > li {
    margin: 10px 0;
}
.bolded {
  font-weight: bold;
}
.v-card.crosswalk {
    background-color: #e8edf8;
    border: 1px solid #d6deed;
    margin: 10px 15px;
    padding: 10px;
    max-width: 1000px;
}
.crosswalklist {
    margin-bottom: 0px;
}
</style>
